import React, { useEffect, useState } from 'react';
import './Kinder.css';
import '../../../styles/CiTable.css';
import { host_url } from '../../../App';
import BackArrow from '../../../BackArrow'; // Importiere die BackArrow-Komponente

function Kinder() {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(`${host_url}/zeltsprecher`)
      .then(response => response.json())
      .then(data => setData(data))
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  return (
    <div>
      <div className="page-header">
        <BackArrow to="/parlament" />
        <h1>Zeltsprecher*innen</h1>
      </div>
      <div className="ci-table-wrapper">
      <table className="ci-table">
        <thead>
          <tr>
            <th>Zelt</th>
            <th>Name</th>
            <th>Größe</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item.Zeltname}</td>
              <td>{item.Kindname}</td>
              <td>{item.TShirtsize}</td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
}

export default Kinder;
